import { render, staticRenderFns } from "./PdfCertificate.vue?vue&type=template&id=ea845b56"
import script from "./PdfCertificate.vue?vue&type=script&lang=js"
export * from "./PdfCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports